module.exports = __webpack_public_path__ + "static/vpn-cross-148d87cb250bbae042a408d4a504c3a8.svg";